module.exports = __webpack_public_path__ + "img/body-3-lg.0fab1e86.png";